import router from 'next/router'
import { React, useState, useEffect } from 'react'

import { useSelector } from 'react-redux';
import * as ga from '../../lib/ga'

function WishListButton({ product_id,url,is_fav }) {


    const wishlist_api_call = async (event, product_id, token) => {
        event.preventDefault()


        const res = fetch(
            process.env.NEXT_PUBLIC_API_URL + '/wishlist',
            {
                body: JSON.stringify({
                    product_id: product_id,
                }),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + token
                },
                method: 'POST'
            }
        )

            .then(response => {
                // reject not ok response
                if (!response.ok) {
                    return Promise.reject(response)
                }
                return response.json() // or return response.text()
            })
            .catch(async response => {
                const error = await response.json().then(text => text)
                return Promise.reject(error)
            })
            .then(data => {
                set_added(true)
                set_is_fav(true)
            })
            .catch((error) => {
                console.warn(error)
            });


    }


    const wishlist_api_call_remove = async (event, product_id, token) => {
        event.preventDefault()
        const res = fetch(
            process.env.NEXT_PUBLIC_API_URL + '/wishlist/' + product_id,
            {
              headers: {
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
              },
              method: 'DELETE'
            }
          ).then(response => {
                // reject not ok response
                if (!response.ok) {
                    return Promise.reject(response)
                }
                return response.json() // or return response.text()
            })
            .catch(async response => {
                const error = await response.json().then(text => text)
                return Promise.reject(error)
            })
            .then(data => {
                set_removed(true)
                set_is_fav(false)
                setTimeout(() => set_removed(false), 2000); // Reset after 2 seconds
            })
            .catch((error) => {
                console.warn(error)
            });

    }

    const [added, set_added] = useState(false)
    const [copied, set_copied] = useState(false)
    const [removed, set_removed] = useState(false)
    const [isFav, set_is_fav] = useState(false)

    const userdata = useSelector((state) => state.user);

    const user = userdata[0]
    var token
    if (user) {
        token = user.token
    }

    const add_to_wishlist = (event, product_id) => {
        event.preventDefault()
        if (!token) {
            router.push('/login/', undefined, { shallow: true })
        }
        wishlist_api_call(event, product_id, token)
        ga.add_to_wishlist(product_id)
    }


    const remove_from_wishlist = (event, product_id) => {
        event.preventDefault()
        if (!token) {
            router.push('/login/', undefined, { shallow: true })
        }
        wishlist_api_call_remove(event, product_id, token)
    }

    const copy_url_clipboard = (event) => {
        event.preventDefault()
        navigator.clipboard.writeText(process.env.NEXT_PUBLIC_SITE_URL+"/product/"+url).then(() => {
            set_copied(true);
            setTimeout(() => set_copied(false), 2000); // Reset after 2 seconds
        }).catch(err => {
            console.error("Failed to copy URL: ", err);
        });
    }

    useEffect(() => {
        set_is_fav(is_fav)
    }, [is_fav])
    
    return (
        <>
            <div className='flex flex-row'>
                {(!isFav ? 
                <button onClick={(event) => add_to_wishlist(event, product_id)} className="btn-add-to-collection relative has-tooltip cursor-pointer w-28 lg:w-auto z-10">
                    <div className="absolute bottom-0 flex flex-col items-center hidden mb-6 has-tooltip-hover:flex">
                        <span className="relative z-10 whitespace-no-wrap rounded p-2 py-1.5 bg-brand-tertiary text-white -mt-12 text-xxs uppercase">Add to Saved Items</span>
                        <div className="w-3 h-3 -mt-2 transform rotate-45 bg-brand-tertiary"></div>
                    </div>
                    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" version="1.1" width="26" height="26" viewBox="0 0 1000 1000">
                            <path fill ="#105e76" d="M716.3,870.2c-23.1,3.8-41.9-9.5-62.6-23.2-16.4-11.1-31.4-21.6-50-34.3-30-20-59.4-41.9-86.4-58.3-10.7-6.3-20.4-7.4-31.2-1.6-5.2,2.5-10.6,6.1-15.9,9.6-29.5,20-69.9,47.8-103.8,71.1-27.3,17.5-53.3,42.4-84.3,36.3-15.3-3.2-29.2-13.9-36-28.1-5.4-11.4-5.9-23.3-3.6-36.8,2.2-13.1,6.8-27.8,12.1-45.8,9.2-31.3,19.2-65.1,28.5-96.5,4.2-14.3,8-26.6,10.5-36.3,2.5-10.8,4.7-18.6,1.2-27.9-2.3-5.7-6.8-10.1-11.7-14.6-36.3-29.7-80.6-62.3-119.9-92.9-29.6-22.5-60.3-44.8-47.7-83,12.8-37.8,51.3-37.2,88.3-38.1,49.1-1.6,104.9-2.2,148.6-4.5,6.5-.7,12.8-1.5,18.1-4.2,8.1-4.4,11.2-11,15.3-20.2,3.9-9.1,8.1-21.5,13.3-36.1,9.4-26.5,20.9-58.7,30.9-87,15.3-39.4,23-89.5,71.7-88.8,35.6,1.6,47.7,30.1,59.2,63,17.8,48.9,36.1,103.9,53.9,150.1,7.5,18.3,16.3,22.3,36,23.5,42.4,2,93.6,2.6,137.5,4,30.9,1.8,57.5-1.9,80,14.6,13.2,10.3,20.3,27.7,19.1,44.3-1.2,14.9-8.6,26.6-20.1,37.6-10.7,10.4-29,23.7-45.1,36.3-32.9,25.7-71.7,54.4-102.7,79.4-15,12.4-18.5,21.3-14,39.9,11.5,43,28.6,97.6,42.3,145.1,5.5,19,12,39.8,11,55-.4,23.5-19.5,44.5-42.5,48.3h-.2ZM188.4,432.4c-1.9,3.1,15.7,15.6,21.5,20.2,35.3,27.1,79.9,61.5,116.6,89.6,10.6,8.3,20.9,15.6,30.5,24.2,13.4,11.2,8.6,23.1,4.8,37.2-11.4,39.2-23.8,80.8-35.4,120.2-6,20.4-10.6,35.8-15.3,52-3.6,13.3-6.7,22-2.7,23,1.9,1.5,19-10.2,27.9-16.5,30.2-20.7,69.6-47.7,101.4-69.5,13.5-9.2,26.3-18.1,39.2-26.8,12.2-8.1,22-15.2,36-6.4,11,6.4,20.8,13.7,31.9,21.2,25.7,17.6,53.5,36.7,79.5,54.5,19.3,13.2,33.3,22.9,49.6,34,10.5,7.1,16.7,10.9,18.8,9.3,2.1-1.5.5-8.5-3-20.5-5.8-19.9-11.1-37.4-18.1-61.3-8.6-29.3-17.9-60.5-26.4-89.5-3.6-12.6-7.5-24.1-10.1-36.4-4.1-16,5.9-23.2,17.4-32.3,11.9-9.3,24-18.5,36.5-28.1,30.8-23.7,68-52.3,97.7-75.1,9.3-7.5,26.3-19,25-23-.8-2.6-8.4-3.1-21.9-3.6-17.8-.6-35.3-.9-58.2-1.6-31.2-.8-64.6-1.8-95.6-2.6-15-.7-28.9,0-43.2-2.2-13.5-1.6-17.6-14.8-22.1-26.7-5.5-15.2-10.9-30.5-16.6-46.5-13-36.6-28.9-81.3-41.2-116.1-2.7-7.3-9.2-27.6-12.7-27.1-2.7-.2-5.4,6.5-9.8,18.6-6.7,18.6-12.4,34.9-20.3,56.9-10.4,29.2-21.5,60.5-31.8,89.4-5.2,13.9-8.9,27.2-15.3,40-5.6,12.3-19,12.3-31.5,12.8-15.8.6-31.7.9-48.3,1.4-39.3,1-88.6,2.4-125.7,3.4-7.6.3-28.6.2-29.1,3.7h0ZM490.9,180.2h0s0,0,0,0h0Z"/>
                    </svg>
                </button>
                :
                <button onClick={(event) => remove_from_wishlist(event, product_id)} className="bg-fav-icon-added btn-add-to-collection relative has-tooltip cursor-pointer w-28 lg:w-auto z-10">
                    <div className="absolute bottom-0 flex flex-col items-center hidden mb-6 has-tooltip-hover:flex">
                        <span className="relative z-10 whitespace-no-wrap rounded p-2 py-1.5 bg-brand-tertiary text-white -mt-8 text-xxs uppercase">Remove from Favourite Items</span>
                        <div className="w-3 h-3 -mt-2 transform rotate-45 bg-brand-tertiary"></div>
                    </div>
                    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" version="1.1" width="26" height="26" viewBox="0 0 1000 1000">
                        <rect fill='#105e76' x="0" width="1000" height="1000"/>
                        <path fill='#fff' d="M887.4,428.6c-1.2,14.9-8.6,26.6-20.1,37.6-10.7,10.5-29,23.7-45.1,36.2-32.9,25.7-71.7,54.4-102.7,79.5-15,12.4-18.5,21.3-14,39.9,11.5,43,28.6,97.6,42.3,145.1,5.5,19,12,39.9,11,55-.4,23.5-19.5,44.5-42.5,48.3h-.2c-23.1,3.8-41.9-9.4-62.6-23.1-16.5-11.1-31.5-21.6-50-34.3-30-20-59.4-41.9-86.4-58.3-10.7-6.3-20.4-7.4-31.2-1.6-5.2,2.5-10.6,6.1-15.9,9.6-29.5,20-69.9,47.8-103.8,71.1-27.3,17.5-53.3,42.4-84.3,36.4-15.3-3.2-29.2-13.9-36-28.1-5.4-11.4-5.9-23.3-3.6-36.8,2.2-13.1,6.8-27.8,12.1-45.8,9.2-31.2,19.2-65.1,28.5-96.5,4.2-14.3,8-26.6,10.5-36.3,2.5-10.8,4.7-18.6,1.2-27.9-2.3-5.7-6.8-10.1-11.7-14.6-36.3-29.7-80.6-62.3-119.9-92.9-29.6-22.5-60.3-44.8-47.6-83,12.8-37.8,51.3-37.2,88.3-38.1,49.1-1.6,104.9-2.2,148.6-4.5,6.5-.7,12.8-1.5,18.1-4.2,8.1-4.4,11.2-11,15.4-20.2,3.8-9.1,8.1-21.5,13.3-36.1,9.4-26.5,20.9-58.7,30.9-87,15.3-39.4,23-89.5,71.7-88.8,35.6,1.6,47.7,30.1,59.2,63,17.8,48.9,36.1,103.9,53.9,150.1,7.5,18.2,16.3,22.3,36,23.5,42.4,2,93.6,2.6,137.5,4,30.9,1.8,57.5-1.9,80,14.6,13.2,10.3,20.4,27.7,19.1,44.3Z"/>
                    </svg>
                </button>
                )}
            
                <button onClick={(event) => copy_url_clipboard(event)} className="btn-add-to-collection relative has-tooltip cursor-pointer w-28 lg:w-auto z-10 ml-2">
                    <div className="absolute bottom-0 flex flex-col items-center hidden mb-6 has-tooltip-hover:flex">
                        <span className="relative z-10 whitespace-no-wrap rounded p-2 py-1.5 bg-brand-tertiary text-white -mt-12 text-xxs uppercase">Share Items</span>
                        <div className="w-3 h-3 -mt-2 transform rotate-45 bg-brand-tertiary"></div>
                    </div>
                    {copied ? (
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#105e76" width="26" height="26">
                            <path d="M9 16.17L4.83 12a1.5 1.5 0 0 0-2.12 2.12l5.59 5.59a1.5 1.5 0 0 0 2.12 0l12-12a1.5 1.5 0 0 0-2.12-2.12L9 16.17z"/>
                        </svg>
                    ) : (
                        <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" version="1.1" width="26" height="26" viewBox="0 0 1000 1000">
                        <path fill='#105e76' d="M786.3,505.5v267.3c0,55.2-44.9,100.1-100.1,100.1h-372.6c-55.1,0-100-44.8-100-100v-267.4c0-54.9,44.7-99.6,99.6-99.6h82.9c16.4,0,29.7,13.3,29.7,29.7s-13.3,29.7-29.7,29.7h-82.4c-22.4,0-40.6,18.2-40.6,40.6v266.5c0,22.6,18.4,41,41,41h371.6c22.7,0,41.1-18.4,41.1-41.1v-266.6c0-22.3-18.1-40.4-40.4-40.4h-82.6c-16.4,0-29.7-13.3-29.7-29.7s13.3-29.7,29.7-29.7h82.9c54.9,0,99.6,44.7,99.6,99.6Z"/>
                        <path fill='#105e76' d="M635.4,302.3l-.8.7c-5.4,4.7-12.2,7.2-19.3,7.2s-.8,0-1.2,0c-7.8-.3-15.2-3.6-20.5-9.4l-63.6-68.5v386.6c0,16.1-13.1,29.2-29.2,29.2h-1.6c-16.1,0-29.2-13.1-29.2-29.2V232.3l-63.6,68.5c-5.4,5.8-12.7,9.1-20.6,9.4-.3,0-.7,0-1.1,0-7.5,0-14.6-2.8-20.1-7.9-11.9-11.1-12.6-29.8-1.5-41.8l115.3-124c5.6-6,13.5-9.4,21.6-9.4s8.1.8,11.8,2.5c3.7,1.6,7,3.9,9.8,6.9l115.2,124c11.1,11.9,10.4,30.7-1.5,41.8Z"/>
                        </svg>
                    )}
                </button>
                {copied && (
                    <div className="fixed top-1/4 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-brand-primary text-white text-xl px-8 py-4 rounded-md shadow-2xl z-50 transition-opacity duration-300">
                        Link copied to clipboard!
                    </div>
                )}
                {removed && (
                    <div className="fixed top-1/4 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-brand-primary text-white text-xl px-8 py-4 rounded-md shadow-2xl z-50 transition-opacity duration-300">
                        Removed from favourites
                    </div>
                )}
            </div>
        </>
    );
}

export default WishListButton;




